import React from 'react';
import { Grid, IconButton } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { Body1 } from './blocks';

const ZipListItem = ({ zip, callbacks, options }) => {
    return (
        <Grid
            container
            direction="row"
            css={css`
                padding: 6px 20px;
                border-bottom: 1px solid ${colors.greys[4]};
            `}
            onMouseEnter={() => {
                callbacks.toggleZipHover(zip.zip);
            }}
            onMouseLeave={() => {
                callbacks.toggleZipHover(zip.zip);
            }}
        >
            <Grid
                container
                direction="column"
                css={css`
                    flex: 1;
                    flex-basis: 0;
                    justify-content: center;
                    margin-right: 12px;
                `}
            >
                <Body1>{zip.zip}</Body1>
            </Grid>
            {!options?.readOnly ? (
                <Grid
                    container
                    direction="column"
                    css={css`
                        flex: 0;
                        flex-basis: 0;
                        justify-content: center;
                    `}
                >
                    <IconButton
                        css={css`
                            padding: 8px;
                        `}
                        onClick={() => callbacks.removeZip(zip)}
                    >
                        <CloseIcon
                            css={css`
                                font-size: 14px;
                            `}
                        />
                    </IconButton>
                </Grid>
            ) : null}
        </Grid>
    );
};

export default ZipListItem;
